let language_pack={
    cn:{
        item:'项目',
        time_zone:'时区',
        language:'语言',
        welcome:'欢迎',
        sign_out:'退出',
        Please_select:'请选择',
        query:'查询',
        refresh:'刷新',
        edit:'编辑',
        newly_build:'新建',
        export:'导出',
        import:'导入',
        preservation:'保存',
        revoke:'撤销',
        del:'删除',
        Show_hide:'显示/隐藏',
        page:'第',
        no_data:'没有数据',
        confirm_deletion:'确认要删除选择的条目吗',
        confirm:'确认',
        cancel:'取消',
        search:'搜索',
        reset:'重置',
        lookup:'查找',
        query_scope:['等于','不包含','不等于','大于','大于等于','小于','小于等于','包含','开头是','开头不是','结尾是','结尾不是','为空','不为空'],
        project_condition:['满足所有条件','满足任一条件'],
        choice:'选择',
        choice_app:'选择应用',
        select_app_type:'选择应用类型',
        // select_distribution_package:'选择发行包',
        choose_gift_package:'选择礼包',
        select_server_group:'选择服务器分组',
        select_mail_template:'选择邮件模板',
        select_gift_package_generation_batch:'选择礼包生成批次',
        select_distribution_package:'选择发行包',
        select_edit:'请输入内容',
        select_server_group:'选择服务器分组',
        mail_conditions:'邮件条件',
        edit_item:'编辑物品',
        please_select_the_following_items:'请选择以下物品',
        is_permission:'没有权限',
        please_select_edit_item:'请选择编辑项',
        please_select_delete_item:'请选择删除项',
        first_page:'已经是第一页了',
        last_page:'已经是最后一页了',
        new_password:'新改密码',
        repeat_password:'重复密码',
        input_result:'两次输入不相同',
        partition:'分区',
        role_name:'角色名',
        version_number:'版本号',
        available_version_number:'可领取版本号',
        grade:'等级',
        creation_time:'创建时间',
        vehicle_ownership:'拥有载具',
        equipped:'拥有装备',
        own_members:'拥有成员',
        select_item:'选择物品',
        heade_data:['物品ID','物品名','数量','操作'],
        id_number:'请输入ID号',
        enter_name:'请输入商品名字',
        data_type:['所有'],
        type:'类型',
        database:'数据库',
        z_project:'项目（工程）',
        table:'表（页面）',
        explain:'说明',
        browse:'浏览',
        increase:'增加',
        modify:'修改',
        data_rights:'数据权限',
        operation:'操作',
        submit:'提交',
        template_id:'模板ID',
        email_title:'邮件标题',
        email_content:'邮件内容',
        enclosure:'附件',
        target_role:'目标角色',
        query_role:'查询角色',
        send_complete_role:'发送完成角色',
        client_mail_template:'客户端邮件模板',
        retention_time:'保留时间',
        delete_method:'删除方式',
        send_mail:'发送邮件',
        input_value:'输入条件值',
        previous_page:'上一页',
        home_page:'首页',
        last_page:'尾页',
        next_page:'下一页',
        user_name:'用户名',
        password:'密码',
        enter_one_user_name:'请输入用户名',
        please_input_a_password:'请输入密码',
        the_user_name_cannot_be_empty:'用户名不能为空',
        password_cannot_be_empty:'密码不能为空',
        login_expired:'登录过期 重新登录',
    },
    en:{
        item:'item',
        time_zone:'time zone',
        language:'translations',
        welcome:'welcome',
        sign_out:'sign out',
        Please_select:'Please select',
        query:'query',
        refresh:'refresh',
        edit:'edit',
        newly_build:'newly build',
        export:'export',
        import:'import',
        preservation:'preservation',
        revoke:'revoke',
        del:'delete',
        Show_hide:'Show hide',
        page:'page',
        no_data:'no data',
        confirm_deletion:'Are you sure you want to delete the selected entry',
        confirm:'confirm',
        cancel:'cancel',
        search:'search',
        reset:'reset',
        lookup:'lookup',
        query_scope:['be equal to','Not included','Not equal to','greater than','Greater than or equal to','less than','Less than or equal to','contain','It starts with','Not at the beginning','The ending is','The end is not','It is empty','Not empty'],
        project_condition:['All conditions are met','Satisfy any condition'],
        choice:'choice',
        choice_app:'choice app',
        select_app_type:'select app type',
        // select_distribution_package:'select distribution package',
        choose_gift_package:'choose gift package',
        select_server_group:'select server group',
        select_mail_template:'select mail template',
        select_gift_package_generation_batch:'select gift package generation batch',
        select_distribution_package:'select distribution package',
        select_edit:'please input the content',
        select_server_group:'select server group',
        mail_conditions:'mail conditions',
        edit_item:'edit item',
        please_select_the_following_items:'please select the following items',
        is_permission:'no permission',
        please_select_edit_item:'please select edit item',
        please_select_delete_item:'please select delete item',
        first_page:'it is the first page',
        last_page:'it is the last page',
        new_password:'new password',
        repeat_password:'repeat the password',
        input_result:'enter the results',
        partition:'partition',
        role_name:'role name',
        version_number:'version number',
        available_version_number:'available version number',
        grade:'grade',
        creation_time:'creation time',
        vehicle_ownership:'vehicle ownership',
        equipped:'equipped',
        own_members:'own members',
        select_item:'select item',
        heade_data:['Item ID','Item name','number','operation'],
        id_number:'Please enter ID number',
        enter_name:'Please enter the name of the product',
        data_type:['all'],
        type:'type',
        database:'database',
        z_project:'Project (Engineering)',
        table:'Table (page)',
        explain:'explain',
        browse:'browse',
        increase:'increase',
        modify:'modify',
        data_rights:'data rights',
        operation:'operation',
        submit:'submit',
        template_id:'template_id',
        email_title:'email_title',
        email_content:'email_content',
        enclosure:'enclosure',
        target_role:'target_role',
        query_role:'query_role',
        send_complete_role:'send_complete_role',
        client_mail_template:'client_mail_template',
        retention_time:'retention_time',
        delete_method:'delete_method',
        send_mail:'send_mail',
        input_value:'input condition value',
        previous_page:'previous page',
        home_page:'home page',
        last_page:'last page',
        next_page:'next page',
        user_name:'user name',
        password:'password',
        enter_one_user_name:'enter one user name',
        please_input_a_password:'please input a password',
        the_user_name_cannot_be_empty:'the user name cannot be empty',
        password_cannot_be_empty:'password cannot be empty',
        login_expired:'Login after expiration',
    },
    jp:{
        item:'アイテム',
        time_zone:'タイムゾーン',
        language:'言語',
        welcome:'歓迎する',
        sign_out:'終了',
        Please_select:'選択してください',
        query:'クエリー',
        refresh:'更新',
        edit:'編集',
        newly_build:'新規作成',
        export:'エクスポート',
        import:'インポート',
        preservation:'保存',
        revoke:'取り消す',
        del:'削除',
        Show_hide:'表示/非表示',
        page:'ページ',
        no_data:'データがありません',
        confirm_deletion:'選択した項目を削除しますか？',
        confirm:'確認',
        cancel:'キャンセル',
        search:'検索',
        reset:'リセット',
        lookup:'クエリー',
        query_scope:['等しい','含まない','等しくない','大きい','大なりイコール','以下','以下','含める','最初は','最初は違います','最後は','最後は違います','空のため','空ではない'],
        project_condition:['すべての条件を満たす','いずれの条件を満たす'],
        choice:'選択',
        choice_app:'選択アプリ',
        select_app_type:'アプリケーションの種類を選択',
        select_distribution_package:'発行パッケージを選択',
        choose_gift_package:'プレゼントを選ぶ',
        select_server_group:'サーバグループを選択',
        select_mail_template:'メールテンプレートを選択',
        select_gift_package_generation_batch:'ギフトバッグを選択してロットを生成します。',
        // select_distribution_package:'発行パッケージを選択',
        select_edit:'内容を入力してください',
        select_server_group:'サーバグループを選択',
        mail_conditions:'メールの条件',
        edit_item:'アイテムを編集',
        please_select_the_following_items:'以下のものを選んでください。',
        is_permission:'権限がありません',
        please_select_edit_item:'編集項目を選択してください',
        please_select_delete_item:'削除項目を選択してください',
        first_page:'もう1ページ目です。',
        last_page:'もう最後のページです。',
        new_password:'パスワードを新しく変更します',
        repeat_password:'パスワードを繰り返す',
        input_result:'結果を入力',
        partition:'パーティション',
        role_name:'キャラクター名',
        version_number:'バージョン番号',
        available_version_number:'受領可能バージョン番号',
        grade:'レベル',
        creation_time:'作成時間',
        vehicle_ownership:'キャリアを持っています',
        equipped:'装備を持つ',
        own_members:'メンバーを持つ',
        select_item:'品物を選ぶ',
        heade_data:['アイテムID','アイテム名','数','操作'],
        id_number:'ID番号を入力してください',
        enter_name:'商品名を入力してください。',
        data_type:['すべて'],
        type:'タイプ',
        database:'データベース',
        z_project:'プロジェクト（プロジェクト）',
        table:'テーブル(ページ)',
        explain:'説明',
        browse:'ブラウズ',
        increase:'増加',
        modify:'変更',
        data_rights:'データ権限',
        operation:'操作',
        submit:'送信',
        template_id:'テンプレートID',
        email_title:'メールのタイトル',
        email_content:'メールの内容',
        enclosure:'添付ファイル',
        target_role:'ターゲットキャラクター',
        query_role:'キャラクターを検索',
        send_complete_role:'完了したキャラクターを送信します',
        client_mail_template:'クライアントのメールテンプレート',
        retention_time:'保持時間',
        delete_method:'削除',
        send_mail:'メールを送る',
        input_value:'条件値を入力',
        previous_page:'前のページ',
        home_page:'最初のページ',
        last_page:'最後のページ',
        next_page:'次のページ',
        user_name:'ユーザ名',
        password:'パスワード',
        enter_one_user_name:'ユーザ名を入力してください',
        please_input_a_password:'パスワードを入力してください',
        the_user_name_cannot_be_empty:'ユーザ名は空ではありません。',
        password_cannot_be_empty:'パスワードが空です',
        login_expired:'ログイン期限が過ぎて再登録します。',
    }
}
export default language_pack